import { apiRequest } from 'api/apiClient';

const fetchRetailers = async ({
  page = 1,
  pageSize = 30,
  search = '',
  ordering = '',
  filters = {},
} = {}) => {
  const response = await apiRequest('GET', '/v1/users/retailer-details', null, {
    params: {
      page,
      page_size: pageSize,
      ...(search ? { search } : {}),
      ...(ordering ? { ordering } : {}),
      ...filters,
    },
  });
  return response;
};

const fetchRetailer = async (uid) => {
  const response = await apiRequest('GET', `/v1/users/retailer-details/${uid}`, null);
  return response;
};

const fetchRetailerLooks = async (uid) => {
  const response = await apiRequest('GET', `/v1/users/retailer-details/${uid}/looks`, null);
  return response;
};

const fetchRetailerFavoriteProducts = async (uid) => {
  const response = await apiRequest(
    'GET',
    `/v1/users/retailer-details/${uid}/favorite-products`,
    null,
  );
  return response;
};

const RETAILERS_QUERIES = {
  FETCH_RETAILERS: fetchRetailers,
  FETCH_RETAILER: fetchRetailer,
  FETCH_RETAILER_LOOKS: fetchRetailerLooks,
  FETCH_RETAILER_FAVORITE_PRODUCTS: fetchRetailerFavoriteProducts,
};

export default RETAILERS_QUERIES;
